"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: issuing/atm-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fissuing%2Fatm-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtmServiceClient = exports.LookupFeeSchemaResponse = exports.LookupFeeSchemaRequest = exports.LocateAtmsResponse = exports.LocateAtmsRequest = exports.AtmAddress = exports.AtmLocation = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const fee_schema_1 = require("../common/fee-schema");
const latlng_1 = require("../google/type/latlng");
const protobufPackage = 'com.step.issuing.proto';
function createBaseAtmLocation() {
    return { address: exports.AtmAddress.fromPartial({}), name: '', hasFees: false };
}
exports.AtmLocation = {
    fromJSON(object) {
        const message = {
            address: isSet(object.address)
                ? exports.AtmAddress.fromJSON(object.address)
                : exports.AtmAddress.fromPartial({}),
            hasFees: isSet(object.hasFees) ? globalThis.Boolean(object.hasFees) : false,
        };
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.address !== undefined) {
            obj.address = exports.AtmAddress.toJSON(message.address);
        }
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        if (message.hasFees !== false) {
            obj.hasFees = message.hasFees;
        }
        return obj;
    },
    create(base) {
        return exports.AtmLocation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmLocation();
        message.address = (object.address !== undefined && object.address !== null)
            ? exports.AtmAddress.fromPartial(object.address)
            : exports.AtmAddress.fromPartial({});
        message.name = object.name ?? '';
        message.hasFees = object.hasFees ?? false;
        return message;
    },
};
function createBaseAtmAddress() {
    return {
        line1: '',
        line2: '',
        city: '',
        stateProvinceRegion: '',
        zipPostalCode: '',
        country: '',
        location: latlng_1.LatLng.fromPartial({}),
    };
}
exports.AtmAddress = {
    fromJSON(object) {
        const message = {
            city: isSet(object.city) ? globalThis.String(object.city) : '',
            country: isSet(object.country) ? globalThis.String(object.country) : '',
            location: isSet(object.location) ? latlng_1.LatLng.fromJSON(object.location) : latlng_1.LatLng.fromPartial({}),
        };
        if (isSet(object.line1)) {
            message.line1 = globalThis.String(object.line1);
        }
        if (isSet(object.line2)) {
            message.line2 = globalThis.String(object.line2);
        }
        if (isSet(object.stateProvinceRegion)) {
            message.stateProvinceRegion = globalThis.String(object.stateProvinceRegion);
        }
        if (isSet(object.zipPostalCode)) {
            message.zipPostalCode = globalThis.String(object.zipPostalCode);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.line1 !== undefined && message.line1 !== '') {
            obj.line1 = message.line1;
        }
        if (message.line2 !== undefined && message.line2 !== '') {
            obj.line2 = message.line2;
        }
        if (message.city !== '') {
            obj.city = message.city;
        }
        if (message.stateProvinceRegion !== undefined && message.stateProvinceRegion !== '') {
            obj.stateProvinceRegion = message.stateProvinceRegion;
        }
        if (message.zipPostalCode !== undefined && message.zipPostalCode !== '') {
            obj.zipPostalCode = message.zipPostalCode;
        }
        if (message.country !== '') {
            obj.country = message.country;
        }
        if (message.location !== undefined) {
            obj.location = latlng_1.LatLng.toJSON(message.location);
        }
        return obj;
    },
    create(base) {
        return exports.AtmAddress.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmAddress();
        message.line1 = object.line1 ?? '';
        message.line2 = object.line2 ?? '';
        message.city = object.city ?? '';
        message.stateProvinceRegion = object.stateProvinceRegion ?? '';
        message.zipPostalCode = object.zipPostalCode ?? '';
        message.country = object.country ?? '';
        message.location = (object.location !== undefined && object.location !== null)
            ? latlng_1.LatLng.fromPartial(object.location)
            : latlng_1.LatLng.fromPartial({});
        return message;
    },
};
function createBaseLocateAtmsRequest() {
    return { location: latlng_1.LatLng.fromPartial({}), noFeesOnly: false };
}
exports.LocateAtmsRequest = {
    fromJSON(object) {
        const message = {
            location: isSet(object.location) ? latlng_1.LatLng.fromJSON(object.location) : latlng_1.LatLng.fromPartial({}),
        };
        if (isSet(object.noFeesOnly)) {
            message.noFeesOnly = globalThis.Boolean(object.noFeesOnly);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.location !== undefined) {
            obj.location = latlng_1.LatLng.toJSON(message.location);
        }
        if (message.noFeesOnly !== undefined && message.noFeesOnly !== false) {
            obj.noFeesOnly = message.noFeesOnly;
        }
        return obj;
    },
    create(base) {
        return exports.LocateAtmsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLocateAtmsRequest();
        message.location = (object.location !== undefined && object.location !== null)
            ? latlng_1.LatLng.fromPartial(object.location)
            : latlng_1.LatLng.fromPartial({});
        message.noFeesOnly = object.noFeesOnly ?? false;
        return message;
    },
};
function createBaseLocateAtmsResponse() {
    return { locations: [] };
}
exports.LocateAtmsResponse = {
    fromJSON(object) {
        const message = {
            locations: globalThis.Array.isArray(object?.locations)
                ? object.locations.map((e) => exports.AtmLocation.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.locations?.length) {
            obj.locations = message.locations.map((e) => exports.AtmLocation.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.LocateAtmsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLocateAtmsResponse();
        message.locations = object.locations?.map((e) => exports.AtmLocation.fromPartial(e)) || [];
        return message;
    },
};
function createBaseLookupFeeSchemaRequest() {
    return { currency: '' };
}
exports.LookupFeeSchemaRequest = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.LookupFeeSchemaRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFeeSchemaRequest();
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseLookupFeeSchemaResponse() {
    return { schema: undefined };
}
exports.LookupFeeSchemaResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.schema)) {
            message.schema = fee_schema_1.FeeSchema.fromJSON(object.schema);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.schema !== undefined) {
            obj.schema = fee_schema_1.FeeSchema.toJSON(message.schema);
        }
        return obj;
    },
    create(base) {
        return exports.LookupFeeSchemaResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFeeSchemaResponse();
        message.schema = (object.schema !== undefined && object.schema !== null)
            ? fee_schema_1.FeeSchema.fromPartial(object.schema)
            : undefined;
        return message;
    },
};
/**
 * Atm Service API.
 */
class AtmServiceClient {
    rpc;
    name = 'com.step.issuing.proto.AtmService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/issuing';
    methods = [{
            name: 'LocateAtms',
            requestType: exports.LocateAtmsRequest,
            responseType: exports.LocateAtmsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'LookupFeeSchema',
            requestType: exports.LookupFeeSchemaRequest,
            responseType: exports.LookupFeeSchemaResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Locates nearest ATMs
     */
    locateAtms(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns fees schema applicable to the current user.
     */
    lookupFeeSchema(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.AtmServiceClient = AtmServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=atm-service.js.map